export default "__VITE_ASSET__WyFfkYcQ__"